import { Button, Card, Nav } from "react-bootstrap";
import { BanIcon } from "@heroicons/react/outline";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { useCallback } from "react";

import { eventCancelled } from "../../../helpers/event";
import { useCourseRegistration } from "../../../services/CourseRegistrationProvider";


const CourseCardFooter = ({
	course
}) => {
	const { cancelRegistration } = useCourseRegistration();

	const handleCancel = useCallback(() => {
		cancelRegistration(course);
	}, [cancelRegistration, course]);

	return (
		<Card.Footer className="class-card-footer">
			<Nav>
				<Nav.Item className="me-auto d-flex align-items-center">
					<Nav.Link as={Link} className="text-blue" to={`/account/classes/${course.id}`}>
						Find Out More &rarr;
					</Nav.Link>
				</Nav.Item>

				<Nav.Item className="align-items-center justify-content-center align-content-center d-flex">
					{
						eventCancelled(course)
							? <span className="text-danger"><BanIcon className="i" /> Event Cancelled</span>
							: (
								<Button className="text-danger" onClick={handleCancel} variant="link">
									Cancel Registration
								</Button>
							)
					}
				</Nav.Item>
			</Nav>
		</Card.Footer>
	);
};

CourseCardFooter.propTypes = {
	course: PropTypes.shape({
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	}).isRequired
};

export default CourseCardFooter;
